<div class="di-carte-facturation-preparee-container">
	<div class="di-carte-facturation-preparee"
		[ngClass]="{'di-carte-facturation-preparee-checkbox': checkbox }">
		<div class="facturation-header">
			<div class="patient-info">
				<ng-container *ngIf="invoice?.patient">
					<div class="nom-prenom">
						<strong>
							{{ fullLastNamePatient | uppercase }} {{ fullFirstNamePatient | firstUpperCase }}
						</strong>
					</div>
					<small class="adresse">{{ adressePatient }}</small>
				</ng-container>
				<ng-container *ngIf="!invoice?.patient">
					<div class="nom-prenom">
						<strong>Patient inexistant</strong>
					</div>
				</ng-container>
			</div>
			<ng-container *ngIf="isMobile">
				<div class="montant-part total-amount">
					<h3>{{ total | priceFormat : 2 }}&nbsp;€</h3>
				</div>
			</ng-container>
			<ng-container *ngIf="!isMobile">
				<div class="facturation-parts">
					<div class="montant-part">
						<small>{{ invoice?.labelAMO ? invoice.labelAMO : "AMO" }}</small>
						<strong>{{
							invoice?.amoTp && invoice.totalPartAMO
								? (invoice.totalPartAMO | priceFormat : 2)
								: "-"
						}}</strong>
					</div>
					<div class="montant-part">
						<small>{{ invoice?.labelAMC ? invoice.labelAMC : "AMC" }}</small>
						<strong>{{
							invoice?.amcTp && invoice.totalPartAMC
								? (invoice.totalPartAMC | priceFormat : 2)
								: "-"
						}}</strong>
					</div>
					<div class="montant-part">
						<small>Patient</small>
						<strong>{{
							invoice?.totalPartPatient ?? 0 | priceFormat : 2
						}}</strong>
					</div>
					<div class="montant-part total-amount">
						<small>Total</small>
						<h3>{{ total | priceFormat : 2 }}&nbsp;€</h3>
					</div>
				</div>
				<div class="facturation-actions">
					<lua-action-secondaire
						libelle="Facturer"
						(click)="facturer()"
					></lua-action-secondaire>
					<lua-bouton-icone
						iconName="more_vert"
						(click)="openMenu($event)"
					></lua-bouton-icone>
				</div>
			</ng-container>
		</div>
		<div *ngIf="!isMobile && invoice.erreurFacturation" class="facturation-erreur">
			<strong>{{invoice.erreurFacturation}}</strong>
		</div>
		<lua-divider-horizontal *ngIf="isMobile" size="small"></lua-divider-horizontal>
		<div *ngIf="isMobile" class="facturation-parts">
			<div class="montant-part">
				<small>{{ invoice?.labelAMO ? invoice.labelAMO : "AMO" }}</small>
				<strong>{{
					invoice?.amoTp && invoice.totalPartAMO
						? (invoice.totalPartAMO | priceFormat : 2)
						: "-"
				}}</strong>
			</div>
			<div class="montant-part">
				<small>{{ invoice?.labelAMC ? invoice.labelAMC : "AMC" }}</small>
				<strong>{{
					invoice?.amcTp && invoice.totalPartAMC
						? (invoice.totalPartAMC | priceFormat : 2)
						: "-"
				}}</strong>
			</div>
			<div class="montant-part">
				<small>Patient</small>
				<strong>{{
					invoice?.totalPartPatient ?? 0 | priceFormat : 2
				}}</strong>
			</div>
		</div>
		<div *ngIf="isMobile && invoice.erreurFacturation" class="facturation-erreur">
			<strong>{{invoice.erreurFacturation}}</strong>
		</div>
		<div *ngIf="isMobile" class="facturation-actions">
			<lua-action-secondaire
				[fullWidth]="false"
				libelle="Facturer"
				size="large"
				(click)="facturer()"
			></lua-action-secondaire>
		</div>
		<div class="patient-additional-info">
			<di-infirmier
				[showMenu]="false"
				*ngIf="invoice?.infirmier"
				[infirmier]="invoice.infirmier"
				[date]="dateInvoice"
				color="CouleurPrimaire"
			></di-infirmier>
			<di-infirmier
				*ngIf="!invoice?.infirmier"
				color="Noir20"
				[showMenu]="false"
			></di-infirmier>
			<lua-bouton-icone *ngIf="isMobile"
				iconName="more_vert"
				(click)="openMenu($event)"
			></lua-bouton-icone>
		</div>
	</div>
	<div *ngIf="checkbox && !isMobile" class="checkbox-container">
		<lua-checkbox
			[checked]="checked"
			(checkedChange)="handleCheck($event)"
		></lua-checkbox>
	</div>
</div>
